/* Native GET facets: no catalogue fetching, price calculation or private data. */
(() => {
  'use strict';
  if (customElements.get('dx-collection-filters')) return;

  class DarnoxCollectionFilters extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const disclosure = this.querySelector('[data-filter-disclosure]');
      const panel = this.querySelector('[data-filter-panel]');
      const trigger = disclosure?.querySelector('summary');
      const form = panel?.querySelector('form');
      if (!trigger || !form) return;
      this.initialized = true;
      // Sorting also works when JavaScript is enabled but native dialogs are absent.
      this.querySelector('[data-filter-sort]')?.addEventListener('change', () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.querySelector('[type="submit"]').click();
      });
      if (!window.HTMLDialogElement) return;
      const dialog = document.createElement('dialog');
      dialog.id = this.dataset.dialogId;
      dialog.className = 'dx-filters__dialog';
      dialog.setAttribute('aria-labelledby', this.dataset.headingId);
      dialog.append(panel);
      this.append(dialog);
      const closeButton = panel.querySelector('[data-filter-close]');
      const pendingCount = panel.querySelector('[data-filter-pending-count]');
      closeButton.hidden = false;
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
      trigger.setAttribute('aria-expanded', 'false');

      const updateCount = () => {
        pendingCount.textContent = String(form.querySelectorAll('input[type="checkbox"]:checked').length);
      };
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        // Closing without Apply discards unsaved choices, including via Escape.
        form.reset();
        updateCount();
        dialog.classList.toggle('dx-filters__dialog--keyboard', event.detail === 0);
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('dx-filters-open');
        closeButton.focus({ preventScroll: true });
      });
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        form.reset();
        updateCount();
        document.documentElement.classList.remove('dx-filters-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus({ preventScroll: true });
      });
      form.addEventListener('change', updateCount);
      this.cleanup = () => {
        if (dialog.open) dialog.close();
        document.documentElement.classList.remove('dx-filters-open');
      };
    }

    disconnectedCallback() {
      this.cleanup?.();
    }
  }
  customElements.define('dx-collection-filters', DarnoxCollectionFilters);
})();
